<template>
  <a-modal
    title="所报班级"
    :maskClosable="false"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @cancel="handleCancel"
    :footer=null
  >
    <div class="course-info">
      <!-- 表格数据 -->
      <a-table
        :columns="columns"
        :dataSource="studentList"
        :pagination="false"
        class="c-table"
        :loading="loading"
      >
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import student from '../../../api/student'

const columns = [
  {
    title: "报名班级",
    dataIndex: "className",
  },
  {
    title: "班级ID",
    dataIndex: "classId",
  },
  {
    title: "学期",
    dataIndex: "termName",
  },
  {
    title: "报名时间",
    dataIndex: "applyDate",
  },
];

export default {
  name: "studentDetailModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      studentDetail: {},
      columns, //列标识数据
      studentList: [], //学生数据
      loading: true,
    };
  },
  methods: {
    //初始化，显示
    init(detail) {
      this.visible = true;
      this.studentDetail = detail;
      this.studentList = [];
      this.getApplyClass();
    },

    //查看学生所报班级
    getApplyClass(){
      this.loading = true;
      student.getApplyClass(this.studentDetail.id).then(res=>{
        this.studentList = res.data;
        this.loading = false;
      }).catch(e=>{
        this.loading = false;
      })
    },

    //隐藏
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";

.course-info{
  text-align: left;
  height: calc(100vh - 240px);
  overflow-y: auto;
  overflow-x: hidden;
  li{
    font-size: 16px;
    line-height: 40px;
    padding: 6px 0px;
    .key{
      display: inline-block;
      font-weight: 600px;
      color: $normal-color-light;
      width: 150px;
      text-align: right;
    }
    .value{
      vertical-align: top;
      color: $normal-color-dark;
      padding-left: 6px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;
      width: calc(100% - 150px);
      .item{
        border-bottom: 1px solid $border-color;
      }
      img{
        width: 100px;
        height: 100px;
        vertical-align: top;
      }
    }
  }
}
</style>